'use strict';

angular.module('msLegacyActivities').directive('msLibraryToggler', [function () {
  return {
    template: '<a href="#" ng-click="libtog.toggle()" aria-label="Toggle in Library"><i class="ss-icon">{{ libtog.activity.inLibrary ? "minus" : "plus" }}</i> Library</a>',
    restrict: 'AE',
    scope: { activity: '=msLibraryToggler' },
    controller: 'LibraryTogglerCtrl',
    controllerAs: 'libtog',
    bindToController: true
  };
}]).controller('LibraryTogglerCtrl', ['eventTrackingSvc', 'librarySvc', function (eventTrackingSvc, librarySvc) {
  this.$onInit = function () {
    var vm = this;
    librarySvc.inLibrary(vm.activity.url).then(function (inLibrary) {
      vm.activity.inLibrary = inLibrary;
    });
    vm.toggle = function () {
      var addRemove = vm.activity.inLibrary ? 'remove' : 'add';
      eventTrackingSvc.fireEvent('activity', 'libraryToggle', vm.activity.url, { activity: vm.activity.url, action: addRemove });
      librarySvc.toggleLibrary(vm.activity.id, vm.activity.inLibrary).then(function () {
        vm.activity.inLibrary = !vm.activity.inLibrary;
      });
    };
  };
}]);